<template>
    <div v-if="$store.state.is_manager">
        <div class="select-container clearfix" style="margin-top: 6%;margin-left: 33%;float: center;">
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="删除文档">
                    <el-cascader ref="cascader" change-on-select :options="form.options" clearable v-model="selectedItemList"></el-cascader>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="open">删除</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import {mapState} from "vuex";

    export default {
        name: "deleteItem",
        mounted: function () {
            var vm = this;
            if (!(vm.$store.state.is_manager)) {
                this.$notify({
                    title: '没有权限',
                    message: '你没有操作当前菜单的权限',
                    type: 'error'
                });
                return;
            }
            if (vm.token == "") {
                var token = vm.getCookie("access-token");
                if (token != null) {
                    vm.$store.commit('UPDATETOKEN', token);
                    vm.token = token;
                }
            }
            this.$nextTick(() => {
                // 请求新增的目录
                axios.get(vm.selectItemList, {
                    withCredentials: true
                }).then((response) => {
                    if (response.data && response.data.status === 401) {
                        window.location = vm.loginRediret;
                        return;
                    }
                    let itemList = response.data.data;
                    if (!itemList || itemList.length === 0) {
                        return;
                    }
                    vm.$set(vm.form, 'options', itemList);
                }).catch(function (error) {
                    vm.requesterrorinfo(error)
                })
            });
        },
        computed: mapState({
            deleteDocument: function (state) {
                return state.deleteDocument;
            },
            selectItemList: function (state) {
                return state.selectItemList;
            },
        }),
        data() {
            return {
                form: {
                    options: [],
                },
                value: '',
                token: '',
                selectedItemList:[]
            }
        },
        methods: {
            getCookie(name) {
                var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
                if (arr = document.cookie.match(reg))
                    return unescape(arr[2]);
                else
                    return null;
            },
            open() {
                this.$confirm('此操作将永久删除该项, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.onSubmit();
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            onSubmit() {
                var vm = this;
                var length = vm.selectedItemList.length;
                if (length == 0) {
                    this.$message.error('请选择要删除的文档或目录!');
                    return;
                } else {
                    // 如果选择删除的文档不为空,查询是否有子项
                    let values = vm.selectedItemList;
                    let itemIndex = values[values.length - 1];
                    axios.post(vm.deleteDocument, {documentIndex: itemIndex}, {
                        withCredentials: true
                    }).then((response) => {
                        if (response.data.code == 4) {
                            this.$message.error('要删除的文档不可包含子项!');
                            return;
                        } else if (response.data.code == 2) {
                            vm.deleteItem(itemIndex);
                            vm.selectedItemList = [];
                            this.$message.success('删除成功!');
                            return;
                        } else {
                            this.$message.error('删除失败!');
                            return;
                        }
                    }).catch(function (error) {
                        this.requesterrorinfo(error)
                    })
                }
            },
            deleteItem(itemIndex) {
                var vm = this;
                var strings = itemIndex.split('-');
                if (strings.length == 1) {
                    // 一级子目录
                    var options = vm.form.options;
                    for (var i = 0; i < options.length; i++) {
                        if (options[i].value == itemIndex) {
                            vm.form.options.splice(i, 1);
                        }
                    }
                } else if (strings.length == 2) {
                    // 二级子目录
                    var options = vm.form.options;
                    for (var i = 0; i < options.length; i++) {
                        if (options[i].children != null) {
                            for (var j = 0; j < options[i].children.length; j++) {
                                if (options[i].children[j].value == itemIndex) {
                                    vm.form.options[i].children.splice(j, 1);
                                }
                            }
                        }
                    }
                } else if (strings.length == 3) {
                    // 三级子目录
                    var options = vm.form.options;
                    for (var i = 0; i < options.length; i++) {
                        if (options[i].children != null) {
                            for (var j = 0; j < options[i].children.length; j++) {
                                if (options[i].children[j].children != null) {
                                    for (var k = 0; k < options[i].children[j].children.length; k++) {
                                        if (options[i].children[j].children[k].value == itemIndex) {
                                            vm.form.options[i].children[j].children.splice(k, 1);
                                        }
                                    }
                                }
                            }
                        }
                    }
                } else if (strings.length == 4) {
                    // 四级子目录
                    var options = vm.form.options;
                    for (var i = 0; i < options.length; i++) {
                        if (options[i].children != null) {
                            for (var j = 0; j < options[i].children.length; j++) {
                                if (options[i].children[j].children != null) {
                                    for (var k = 0; k < options[i].children[j].children.length; k++) {
                                        if (options[i].children[j].children[k] != null) {
                                            for (var l = 0; l < options[i].children[j].children[k].children.length; l++) {
                                                if (options[i].children[j].children[k].children[l].value == itemIndex) {
                                                    vm.form.options[i].children[j].children[k].children.splice(l, 1);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            requesterrorinfo(error) {
                var vm = this;
                if (error.response) {
                    var code = error.response.status;
                    if (code == 401) {
                        document.cookie = "currentURL=deleteItem";
                        window.location = vm.loginRediret;
                    } else {
                        if (code == 404) {
                            vm.$notify({
                                title: '提示',
                                message: '404:Not found!',
                                type: 'error'
                            });
                        } else {
                            vm.$notify({
                                title: '提示',
                                message: '501:服务端未响应!',
                                type: 'error'
                            });
                        }
                    }
                } else {
                    vm.$notify({
                        title: '提示',
                        message: '502:服务端未响应!',
                        type: 'error'
                    });
                }
            },
            getCookie(name) {
                var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
                if (arr = document.cookie.match(reg))
                    return unescape(arr[2]);
                else
                    return null;
            },
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// deleteItem.vue?422715e8